import script from "./DashboardTableRowLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTableRowLoader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTableRowLoader.vue?vue&type=style&index=0&id=518290c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518290c4"]])

export default __exports__